import { useNavigate } from "react-router-dom"

const PaymentCancel = () => {
    const navigate = useNavigate()
    return (
        <div className="result">
            <div className="container">
                <div className="result-main">
                    <div className="result-left">
                        <h2 className="caption-two result-title">Payment canceled</h2>
                        <h4 className="result-description">
                            You can try again later from the Credits page.
                        </h4>
                        <button className="btn btn-dark result-button" onClick={() => navigate(`/`)}>
                            Done
                        </button>
                    </div>
                    <div className="result-right">
                        <img className="result-picture" src="../../../images/payment-failed.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentCancel


